// extracted by mini-css-extract-plugin
export default {"formGroup":"TextArea_formGroup__hT-qa","ql-image":"TextArea_ql-image__+OzoJ","charCounter":"TextArea_charCounter__dlypY"};